import { siteUrl } from '../EnvUtils';
import { getCurrentAppState } from '../components/AlmeApp/AlmeAppState';
import { getCurrentLaunchTypeCookieValue } from '../components/AlmeLaunchPoint/LaunchTypeCookie';
import { updateCurrentRequiresQualtricsCookieValue } from '../utils/RequiresQualtricsCookie';
/**
 * Origin - required for mocking window.location.origin in unit tests
 */
const Origin = window.location.origin;
/**
 * Url path name
 */
const PathName = window.location.pathname;
const isRelativePath = (url) => url.charAt(0) === "/" || (url.substring(0, 2) === "./") || (url.substring(0, 3) === "../");
const removeSubdomain = (domain) => {
    let urlSubdomains = domain.replace(/[^.]/g, "").length;
    //remove subdomains while they are still present in either url
    while (urlSubdomains > 1) {
        const first = domain.split('.')[0];
        domain = domain.replace(first, ""); //remove domain name
        domain = domain.substring(1); //remove '.'
        urlSubdomains--; //dec for loop
    }
    return domain;
};
/**
* @param url
*/
function isExternal(url) {
    const regex = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/?\n]+)/;
    try {
        //check for same-path traversal
        if (isRelativePath(url)) {
            return false;
        }
        //initial 'easy' parse
        const host = regex.exec(window.location.host);
        let domain = regex.exec(url);
        //check for protocol-relative url, remove slashes and rerun regex
        if (url.substring(0, 2) === "//") {
            url = url.replace("//", "");
            domain = regex.exec(url);
        }
        if (domain && host) {
            if (domain[1][domain[1].length - 1] === ".") {
                domain[1] = domain[1].substring(0, domain[1].length - 1);
            }
            if (host[1][host[1].length - 1] === ".") {
                host[1] = host[1].substring(0, host[1].length - 1);
            }
            domain[1] = removeSubdomain(domain[1]);
            host[1] = removeSubdomain(host[1]);
            //compare domains
            return (host[1] !== domain[1]);
        }
    }
    catch (ex) {
        console.log(ex);
    }
    //unrecognized url, assume external
    return true;
}
function getQueryParameterByName(name, url = window.location.href) {
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
let qualtricsIntercept;
let loginType = '';
let interceptStringName = '';
function getSurveyUrl(almeAppConfig, isLiveChat, surveyUrl, isLoggedIn, chatId, jsSessionId) {
    let originalSurveyUrl = surveyUrl;
    let finalSurveyURL = '';
    if (requiresQualtricsSurvey(almeAppConfig) && almeAppConfig["Qualtrics.Intercepts"] !== undefined && almeAppConfig["Qualtrics.QZoneID"] !== undefined) {
        const qualtricsInterceptID = getQualtricsInterceptID(almeAppConfig, isLiveChat, isLoggedIn);
        const qZoneID = almeAppConfig["Qualtrics.QZoneID"];
        fetchQualtrics(qZoneID);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
        originalSurveyUrl = extractQualtricsSurveyURL(qualtricsIntercept, qualtricsInterceptID);
        // In the event the intercept's sample rate logic gives us an empty string, don't show the survey.
        if (originalSurveyUrl === '') {
            return '';
        }
        finalSurveyURL = getCompleteQualtricsSurveyUrl(originalSurveyUrl, isLiveChat);
    }
    else if (!requiresQualtricsSurvey(almeAppConfig) && !isLiveChat && isLoggedIn !== undefined && chatId && jsSessionId) {
        const chatType = isLoggedIn ? "postlogin" : "prelogin";
        const pageURL = siteUrl && siteUrl.length > 1 ? siteUrl : almeAppConfig.webURL;
        finalSurveyURL = getCompleteSurveyUrl(surveyUrl, `?chattype=${chatType}&chatid=${chatId}&icon=sync1&turl=${pageURL}/Conversationhistory.html?JsSessionId=${jsSessionId}&parent=${siteUrl}/`);
    }
    else if ((!requiresQualtricsSurvey(almeAppConfig) && isLiveChat) && (surveyUrl === undefined || surveyUrl === '')) {
        return finalSurveyURL;
    }
    else {
        return '';
    }
    return finalSurveyURL;
}
function getCompleteQualtricsSurveyUrl(qualtricsOriginalUrl, isLiveChat) {
    let finalSurveyURL = '';
    const almeAppState = getCurrentAppState();
    if (almeAppState.chatId !== undefined) {
        if (!isLiveChat) {
            finalSurveyURL = qualtricsOriginalUrl + "&Launch_Type=" + getCurrentLaunchTypeCookieValue() + "&Session_ID=" + almeAppState.chatId + "&ExternalDataReference="
                + almeAppState.chatId + "&Login_Type=" + loginType + "&Intercept=" + interceptStringName;
            return finalSurveyURL;
        }
        else if (isLiveChat && almeAppState.liveChatCaseID !== undefined) {
            finalSurveyURL = qualtricsOriginalUrl + "&Launch_Type=" + getCurrentLaunchTypeCookieValue() + "&Session_ID=" + almeAppState.chatId + "&ExternalDataReference="
                + almeAppState.chatId + "&Login_Type=" + loginType + "&Intercept=" + interceptStringName + "&LiveChatCaseID=" + almeAppState.liveChatCaseID;
            return finalSurveyURL;
        }
    }
    return finalSurveyURL;
}
let usedQualtricsSurveyID;
export function getQualtricsInterceptID(almeAppConfig, isLiveChat, isLoggedIn) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
    const qualtricsInterceptString = JSON.stringify(almeAppConfig["Qualtrics.Intercepts"]);
    /* eslint-disable @typescript-eslint/no-unsafe-member-access*/
    /* eslint-disable @typescript-eslint/no-unsafe-call*/
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
    const qualtricsInterceptList = JSON.parse(JSON.parse(qualtricsInterceptString));
    // Intercept ID is first set to prelogin NO live chat.
    let targetedQualtricsIntercept = qualtricsInterceptList.PreLogin;
    // eslint-disable-next-line sonarjs/no-duplicate-string
    loginType = "Pre%20Login%20IVA";
    interceptStringName = "Pre%20Login%20Ext%20IVA%20Only";
    // Intercept ID is changed based on conversation conditions isLiveChat and isLoggedIn.
    if (isLiveChat && !isLoggedIn) {
        targetedQualtricsIntercept = qualtricsInterceptList.PreLoginLiveChat;
        loginType = "Pre%20Login%20Live%20Chat";
        interceptStringName = "Pre%20Login%20LIVE%20CHAT%20(after%20Ext%20IVA)";
    }
    else if (isLiveChat && isLoggedIn) {
        targetedQualtricsIntercept = qualtricsInterceptList.PostLoginLiveChat;
        loginType = "Post%20Login%20Live%20Chat";
        interceptStringName = "Post%20Login%20LIVE%20CHAT%20(after%20Ext%20IVA)";
    }
    else if (!isLiveChat && isLoggedIn) {
        targetedQualtricsIntercept = qualtricsInterceptList.PostLogin;
        loginType = "Post%20Login%20IVA";
        interceptStringName = "Post%20Login%20Ext%20IVA%20Only";
    }
    return targetedQualtricsIntercept;
}
function getCompleteSurveyUrl(surveyUrl, queryParameters) {
    return `${surveyUrl}${queryParameters}`;
}
// This is a temporary method while we are going through the transition from Moxie to NICE
function requiresQualtricsSurvey(almeAppConfig) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
    const niceAccessKeys = almeAppConfig["MoxieToNice.AccessKeys"];
    let qualtricsRequired = false;
    const almeAppState = getCurrentAppState();
    if (niceAccessKeys !== undefined && almeAppState.accessKey !== undefined && niceAccessKeys.includes(almeAppState.accessKey)) {
        qualtricsRequired = true;
        updateCurrentRequiresQualtricsCookieValue("true", almeAppConfig);
    }
    else {
        updateCurrentRequiresQualtricsCookieValue("false", almeAppConfig);
    }
    return qualtricsRequired;
}
function fetchQualtrics(qZoneID) {
    void fetchQualtricsData(qZoneID);
}
async function fetchQualtricsData(qZoneID) {
    // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-explicit-any
    let interceptInfo;
    if (qualtricsIntercept === undefined) {
        try {
            const response = await fetch('https://siteintercept.qualtrics.com/WRSiteInterceptEngine/Targeting.php?Q_ZoneID=' + qZoneID + '&Q_CLIENTVERSION=1.106.0&Q_CLIENTTYPE=web');
            interceptInfo = await response.json();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            qualtricsIntercept = interceptInfo.ClientSideIntercepts;
        }
        catch (error) {
            console.log(error);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractQualtricsSurveyURL(qualtricsInterceptList, targetedQualtricsIntercept) {
    let finalSurveyURL = "";
    const almeAppState = getCurrentAppState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (qualtricsInterceptList !== undefined) {
        for (const value of qualtricsInterceptList) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (targetedQualtricsIntercept === value.InterceptID) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
                finalSurveyURL = value.ActionSets[0].Target.OriginalURL;
                if (almeAppState.isSpanishLiveChatConnected && value.ActionSets[1] !== undefined) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    finalSurveyURL = value.ActionSets[1].Target.OriginalURL;
                    finalSurveyURL = finalSurveyURL + "&Q_Language=ES";
                    return finalSurveyURL;
                }
                else if (finalSurveyURL === null || finalSurveyURL === undefined) {
                    finalSurveyURL = '';
                }
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
                usedQualtricsSurveyID = value.ActionSets[0].SurveyID;
                return finalSurveyURL;
            }
        }
    }
    return finalSurveyURL;
}
function getWebLogAPIUrl(almeApiHostName) {
    const apiHostName = almeApiHostName !== undefined ? almeApiHostName : "";
    const apiURL = "/AlmeAPI/api/UIRequestLogger/SendInput";
    return `https://${apiHostName}${apiURL}`;
}
export { isExternal, Origin, PathName, getQueryParameterByName, getSurveyUrl, getCompleteSurveyUrl, getWebLogAPIUrl, requiresQualtricsSurvey, fetchQualtrics, fetchQualtricsData, extractQualtricsSurveyURL, usedQualtricsSurveyID };
